var $ = require('../lib/jquery/dist/jquery.min')

$(function() {
  $('.gotop').click(function() {
    $('html,body').animate({
      scrollTop: 0
    })
  })
});